import transactionsEn from './transactions/en.json';
import transactionsZhHant from './transactions/zh-Hant.json';
import transactionsVi from './transactions/vi.json';
import transactionsTh from './transactions/th.json';

export default {
  en: transactionsEn,
  'zh-Hant': transactionsZhHant,
  vi: transactionsVi,
  th: transactionsTh,
};
